// extracted by mini-css-extract-plugin
module.exports = {"switchMarker":"Switch_switchMarker__5JXNb","switchContainer":"Switch_switchContainer__U8uq4","true":"Switch_true__kZ7W0","shimmer":"Switch_shimmer__VHsiW"};